import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Container } from 'rsuite';
import { LoadingSpinerArea } from '../../../../../components';
import { getAnaliseCompetitividadeRoute, mapMonitoramentoDetalheToAnaliseCompetitividade } from '../analiseCompetitividadeMapper';
import { notify } from '../notify';
import { getMonitoramentoDetalhe } from '../services';

// Ponto de entrada por URL (usado pelo link "Abrir análise" do e-mail de resumo diário) para o
// mesmo fluxo que o botão "Abrir análise" da listagem já faz via handleOpenAnalysis: busca o
// detalhe do monitoramento pelo id, monta o filtro da Análise de Competitividade e navega pra lá.
// Sem essa rota, um link puro (sem o location.state que o clique do botão carrega) cai em branco.
export const AbrirAnaliseRedirect = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    let isMounted = true;

    const openAnalysis = async () => {
      try {
        const { data: detalhe } = await getMonitoramentoDetalhe(Number(id));
        const state = mapMonitoramentoDetalheToAnaliseCompetitividade(detalhe);

        if (isMounted) {
          history.replace(getAnaliseCompetitividadeRoute(detalhe.tipo), state);
        }
      } catch {
        if (isMounted) {
          notify('error', 5000, 'Não foi possível abrir a análise desse monitoramento.');
          history.replace('/isa/central-de-monitoramento');
        }
      }
    };

    openAnalysis();

    return () => {
      isMounted = false;
    };
  }, [id, history]);

  return (
    <Container className="main-container">
      <LoadingSpinerArea area="central-de-monitoramento" size="md" style={{ position: 'absolute' }} />
    </Container>
  );
};
